// Sjåførens kjøretøy (vehicles/{id}): valg, validering og normalisering. Grensene følger Firestore-reglene.

import { TRUCK_CATEGORIES, categoryAxles, supportsTrailer } from './truckCatalog';

// Nye bilkategorier fra katalogen, pluss de eldre typene som fortsatt kan ligge på eksisterende kjøretøy.
export const VEHICLE_TYPES = [
  ...TRUCK_CATEGORIES.map(c => ({ value: c.value, label: c.label })),
  { value: 'flatbed', label: 'Flatbed' },
  { value: 'other',   label: 'Annet' },
];

export const FUEL_TYPES = [
  { value: 'diesel',   label: 'Diesel' },
  { value: 'electric', label: 'Elektrisk' },
  { value: 'hybrid',   label: 'Hybrid' },
];

export const VEHICLE_LIMITS = { plateMax: 12, capacityMax: 100 };

export const vehicleTypeLabel = type => VEHICLE_TYPES.find(t => t.value === type)?.label ?? type;

// Feilmeldinger per felt; tomt objekt betyr gyldig.
export function validateVehicle(form) {
  const errors = {};
  if (!VEHICLE_TYPES.some(t => t.value === form.type)) errors.type = 'Velg kjøretøytype.';
  const axleOptions = categoryAxles(form.type);
  if (axleOptions.length > 0 && !axleOptions.includes(Number(form.axles))) errors.axles = 'Velg antall aksler.';
  const plate = String(form.registrationPlate ?? '').trim();
  if (!plate) errors.registrationPlate = 'Fyll inn registreringsnummer.';
  else if (plate.length > VEHICLE_LIMITS.plateMax) errors.registrationPlate = `Maks ${VEHICLE_LIMITS.plateMax} tegn.`;
  const cap = Number(String(form.capacityTons ?? '').replace(',', '.'));
  if (String(form.capacityTons ?? '').trim() === '' || !Number.isFinite(cap) || cap <= 0) errors.capacityTons = 'Kapasiteten må være over 0 tonn.';
  else if (cap > VEHICLE_LIMITS.capacityMax) errors.capacityTons = `Maks ${VEHICLE_LIMITS.capacityMax} tonn.`;
  return errors;
}

// Det som lagres på kjøretøyet.
export function normalizeVehicle(form) {
  return {
    type: form.type,
    axles: categoryAxles(form.type).length > 0 ? Number(form.axles) : null,
    capacityTons: Number(String(form.capacityTons).replace(',', '.')),
    fuelType: form.fuelType,
    registrationPlate: String(form.registrationPlate).trim().toUpperCase(),
    loadingEquipment: Array.isArray(form.loadingEquipment) ? form.loadingEquipment : [],
    hasTrailer: form.hasTrailer === true && supportsTrailer(form.type),
  };
}

// Varselmatching (users.equipment, lest av notifyDrivers) bruker karosserinøkler. Siden utstyrskortet på profilsiden er
// fjernet, følger de kjøretøytypen sjåføren velger i kjøretøydetaljene.
export const VEHICLE_TYPE_EQUIPMENT = {
  tipper: 'tipp', hooklift: 'krokloft', crane: 'kran', crane_grab: 'kran', liftdumper: 'liftdumper',
  flatbed: 'semitrailer', other: 'annet',
};

// Eksisterende users.equipment beholdes (aldri færre varsler), og kjøretøytypens nøkkel legges til.
export function mergeDriverEquipment(existing, vehicleType) {
  const current = Array.isArray(existing) ? existing : [];
  const key = VEHICLE_TYPE_EQUIPMENT[vehicleType];
  return key && !current.includes(key) ? [...current, key] : current;
}
